var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('ReportTemplate',{attrs:{"loading":!_vm.initialized,"title":"GL Transactions","permission":_vm.PERMISSION_CODES.CMS_VIEW_REPORT_GL_TRANSACTIONS,"filters":_vm.filters,"columns":_vm.columns,"fetchRoute":"/reports/gl-transactions","reportTypeCode":_vm.REPORT_MASTER_CODES.GL_ACCOUNT_TRANSACTION}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }